import Resource from "../Resource";
import RecordSource from "../DataSource/RecordSource";
import Record from "../Resource/Record";

export default class AktivitaService{
  constructor(server){
    this.server = server;
  }

  list(zakaznikId, projektId){
    return this.server("getAktivity", {zakaznik_id: zakaznikId, projekt_id: projektId});
  }

  add(zakaznikId, projektId, aktivita){
    return this.server("addAktivita", {"projekt_id": projektId, "zakaznik_id": zakaznikId, text:aktivita.text, privatna: aktivita.privatna})
  }

  update(aktivita){
    return this.server("updateAktivita", {aktivita: aktivita});
  }

  remove(aktivita){
    return this.server("removeAktivita", {id: aktivita.id});
  }

  setPrivate(aktivitaId, privatna){
    return this.server("setPrivateAktivita", {id: aktivitaId, privatna: privatna});
  }

  getAktivitaRecordSource(config = {}){
    return new RecordSource(new Resource(this.server, "TypAktivity"), this.server, "TypAktivity.list", config);
  }

}


// WEBPACK FOOTER //
// ./src/services/AktivitaService.js